import { addVisible, removeVisible } from './helper';
const CLS = '.validate--tooltip-equals';

export function validateEquals(input1: HTMLInputElement, input2: HTMLInputElement): boolean {
    if (input1.value.length > 0 && input2.value.length > 0) {
        const valid = input1.value === input2.value;
        if (valid) {
            removeVisible(input2, CLS);
            return true;
        } else {
            addVisible(input2, CLS);
            return false;
        }
    }
    // Required validator takes care of empty fields...
    return true;
}

export function liveValidateEquals(input1: HTMLInputElement, input2: HTMLInputElement) {
    function validate(e: InputEvent) {
        validateEquals(input1, input2);
    }
    input1.addEventListener('change', validate);
    input1.addEventListener('input', validate);
    input1.addEventListener('blur', validate);
    input2.addEventListener('change', validate);
    input2.addEventListener('input', validate);
    input2.addEventListener('blur', validate);
}
